import { useEffect, useState } from 'react';

import BlurryLoadingImage from '@/components/progressive-img';
import { safeModalClick } from '@/Layout/download/event';

import styles from './styles.module.less';

const PwaSafeModal = () => {
  const [time, setTime] = useState(0);

  useEffect(() => {
    let i = 0;
    setTime(i);
    const timer = setInterval(() => {
      if (i > 100) {
        clearInterval(timer);
        return;
      }
      setTime(i++);
    }, 100);

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, []);

  const renderSubBox = () => {
    if (time < 100) {
      return (
        <div className={styles.loading_box}>
          <div className={styles.loading_text}>{time}%</div>
          <svg className={styles.arc} viewBox="0 0 100 100" width="200" height="200">
            <path
              d="M 50,50 m -37.5,0 a 37.5,37.5 0 1,0 75,0 a 37.5,37.5 0 1,0 -75,0"
              stroke="#01875F"
              strokeWidth="3"
              fill="none"
            />
          </svg>
        </div>
      );
    }
    return (
      <div className={styles.active}>
        <div className={styles.active_top}>
          <BlurryLoadingImage loading="lazy" src={'/googlePlay/ic_actived.webp'} />
          <span>Activated</span>
        </div>
        <div className="VfPpkd-dgl2Hf-ppHlrf-sM5MNb" data-is-touch-wrapper="true">
          <button onClick={safeModalClick} className={styles.btn}>
            Install now
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.main}>
      <h3 className={styles.title}>
        <BlurryLoadingImage loading="lazy" src={'/googlePlay/ic_raid_install.webp'} />
        <span>Quick installation</span>
      </h3>
      <div className={styles.sub_box}>4 times faster</div>
      {renderSubBox()}
    </div>
  );
};

export default PwaSafeModal;
